import { authRoleAccess } from "auth/AuthRoleAccess";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import DatasetLinkedOutlinedIcon from "@mui/icons-material/DatasetLinkedOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import TopicOutlinedIcon from "@mui/icons-material/TopicOutlined";
import SegmentIcon from "@mui/icons-material/Segment";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import i18n from "i18n/config";

export const navigationItems = [
  {
    title: () => i18n.t("navigation.dashboard"),
    path: "/dashboard",
    icon: <GridViewOutlinedIcon />,
    roles: authRoleAccess.dashboard,
  },

  {
    title: () => i18n.t("navigation.allTopics"),
    path: "/all_topics",
    icon: <SegmentIcon />,
    roles: authRoleAccess.allUsers,
  },

  {
    title: () => i18n.t("navigation.dataSetup"),
    icon: <DatasetLinkedOutlinedIcon />,
    submenu: [
      {
        title: () => i18n.t("navigation.category"),
        path: "/category",
        roles: authRoleAccess.adminOnly,
        icon: <CategoryOutlinedIcon />,
      },
      {
        title: () => i18n.t("navigation.topic"),
        path: "/topics",
        roles: authRoleAccess.adminOnly,
        icon: <TopicOutlinedIcon />,
      },
    ],
  },
  {
    title: () => i18n.t("navigation.userManagement"),
    icon: <PeopleOutlineIcon />,
    submenu: [
      {
        title: () => i18n.t("navigation.adminAccounts"),
        path: "/admin_accounts",
        icon: <AdminPanelSettingsOutlinedIcon />,
        roles: authRoleAccess.adminOnly,
      },

      {
        title: () => i18n.t("navigation.allUsers"),
        path: "/all_journalists",
        icon: <ListAltOutlinedIcon />,
        roles: authRoleAccess.adminOnly,
      },
    ],
  },
  /* {
    title: 'Documentation',
    path: '/themes/examples',
    icon: <GridViewOutlinedIcon />,
    roles: authRoleAccess.themeExamples,
  }, */
];
